import { Exercise as ComponentExercise, ExerciseType as ApiExerciseType, PronunciationPracticeData } from "@/services/admin/exercises.interfaces";
import { EditorInterface } from "./EditorInterface";
import { Mic } from "lucide-react";
import { ExerciseType } from "./types";

/**
 * Editor para exercícios de falar a frase (versão unificada)
 * Focado especificamente em exercícios de pronúncia de uma frase determinada
 */
export class SpeakTheSentenceInfo extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício de falar a frase
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): {
    title: string;
    subtitle: string;
    description?: string;
  } {
    if (!exercise || !SpeakTheSentenceInfo.SupportsExerciseType(exercise.type as unknown as string)) {
      return {
        title: 'Falar a Frase',
        subtitle: 'Sem detalhes',
      };
    }

    try {
      // Tenta extrair os dados do exercício, lidando com diferentes formatos
      let sentence = 'Sem frase para falar';
      let instructions = 'Sem instruções adicionais';
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as PronunciationPracticeData;
        sentence = data.sentence || data.question || 'Sem frase para falar';
        instructions = data.instructions || 'Sem instruções adicionais';
      } 
      // Se os dados estiverem no formato plano
      else if ('sentence' in exercise) {
        sentence = (exercise as any).sentence || 'Sem frase para falar';
        instructions = (exercise as any).instructions || 'Sem instruções adicionais';
      }
      
      return {
        title: "Falar a Frase",
        subtitle: sentence.length > 60 ? `${sentence.substring(0, 60)}...` : sentence,
        description: instructions !== 'Sem instruções adicionais' ? instructions : undefined,
      };
    } catch (error) {
      console.error("Erro ao processar dados do exercício de falar a frase:", error);
      return {
        title: 'Falar a Frase',
        subtitle: 'Erro ao processar dados',
      };
    }
  }
  
  /**
   * Retorna o título do tipo de exercício de falar a frase
   */
  static getTitle(): string {
    return "Falar a Frase";
  }
  
  /**
   * Retorna uma descrição formatada para o exercício de falar a frase
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    if (!exercise) {
      return "Sem detalhes";
    }
    
    try {
      // Tenta extrair os dados do exercício, lidando com diferentes formatos
      let instructions = 'Sem instruções adicionais';
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as PronunciationPracticeData;
        instructions = data.instructions || 'Sem instruções adicionais';
      } 
      // Se os dados estiverem no formato plano
      else if ('instructions' in exercise) {
        instructions = (exercise as any).instructions || 'Sem instruções adicionais';
      }
      
      return instructions !== 'Sem instruções adicionais' ? instructions : "Exercício de pronúncia de frase";
    } catch (error) {
      console.error("Erro ao processar dados do exercício:", error);
      return "Erro ao processar dados";
    }
  }
  
  /**
   * Retorna o ícone para exercícios de falar a frase
   */
  static getIcon() {
    return Mic;
  }
  
  /**
   * Verifica se o exercício é do tipo de falar a frase
   */
  static SupportsExerciseType(type: string): boolean {
    return type === ExerciseType.SpeakTheSentence;
  }
}